import { ApplicationState } from '.';

const initialState: ApplicationState = {
    internalUser: {
        userName: '',
        userType: undefined,
        accessTokens: {},
        roles: [],
        requestedPage: undefined,
        isAuthenticated: false,
        authenticating: false,
        msalReady: false,
        idToken: undefined,
        employeeid: undefined,
        useremail: undefined
    },
    empData:  {
            employeeDetail: {
                employeeId: "",
                employeeFirstName: "",
                employeeLastName: "",
                userPrincipalName: "",
                stationName: "",
                contractName: "",
                isActiveQuestionApplyPTO: ""
            },
            schedules: [
                {
                employeeId: '',
                scheduleId: '',
                stringSchedule_StartTime: '',
                stringSchedule_EndTime: '',
                stringSchedule_Hours: '',
                },
            ],
            absentDetails: [
                {
                absentReasonId: '',
                reasonDescription: ''
                },
            ]
            }
 };

export default initialState;
